module.exports = {"information":"Information","waiting":"Waiting for validation"};